import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { VehicleSearchDto } from '../../vehicles';

/**
 * Resolved related records for a vehicle road worthy check activity event, keyed by relation.
 */
export class VehicleRoadWorthyCheckActivityEventHydration {
  vehicle?: ActivityFieldHydration<VehicleSearchDto>;
  link?: ActivityLinkHydration;
}
